import { useEffect } from 'react';

const PageView = ({ page }) => {
  const datalayer = window.dataLayer;

  useEffect(() => {
    if (datalayer) {
      datalayer.push({
        event: 'ga_virtual_pageview',
        ga_virtual_pageview: {
          pagepath: page
        }
      });
    }
  }, []);

  return null;
};

export default PageView;
